const cacheId = (typename: string, id: string) =>
  `${typename}:{"sys":{"id":"${id}"}}`
export default cacheId
